<template>
    <PersonCard
        :person="person"
        :permissions="permissions"
        @clicked="(clickedValue) => $emit('clicked', clickedValue, person)"
    >
        <div class="flex">
            <ul class="m-0">
                <!-- EMAIL -->
                <li class="mb-1 fs-3 mb-1">
                    <h4 class="h4-label mt-0">
                        Staff #{{ person.sellsyadmin.staff_id }}
                        <i
                            class="ml-2 mr-1 fa"
                            :class="[activeStatus.icon, activeStatus.colorClass]"
                        ></i>
                        {{ activeStatus.label }}

                        <div
                            v-if="parseInt(person.sellsyadmin.staff_ownerid) == 0"
                            class="dinlineb"
                        >
                            <div class="mx-1 chip chip-error"></div>
                            {{ $l10n.__('Propriétaire') }}
                        </div>
                        <div v-else class="dinlineb">
                            <div class="mx-1 chip" :class="[activeStaffType.icon]"></div>
                            {{ activeStaffType.label }}
                        </div>
                    </h4>
                </li>
                <li
                    v-if="
                        person.sellsyadmin.staff_isAdmin ||
                        parseInt(person.sellsyadmin.staff_ownerid) == 0
                    "
                >
                    <div class="chip chip-error"></div>
                    {{ $l10n.__('Admin') }}
                </li>
                <li
                    v-if="
                        person.sellsyadmin.staff_type === 'regular' ||
                        person.sellsyadmin.staff_type === 'temporary'
                    "
                >
                    <div class="chip chip-primary"></div>
                    {{ $l10n.__('Collaborateur') }}
                </li>
                <li
                    v-if="
                        (person.sellsyadmin.staff_type === 'regular' ||
                            person.sellsyadmin.staff_type === 'temporary') &&
                        person.sellsyadmin.staff_isDecisionMaker
                    "
                >
                    <div class="chip chip-warning"></div>
                    {{ $l10n.__('Décisionnaire') }}
                </li>
            </ul>
        </div>
    </PersonCard>
</template>
<script>
import PersonCard from 'vcomponents/utilities/PersonCard.vue';

export default {
    components: {
        PersonCard,
    },
    props: {
        person: {
            type: Object,
            required: true,
            default: () => {},
        },
        permissions: {
            type: [Array, Object],
            required: false,
            default: () => [],
        },
    },
    computed: {
        sellsyadmin() {
            return this.person.sellsyadmin;
        },
        staffStatus() {
            return [
                {
                    label: this.$l10n.__('Actif'),
                    value: 'ok',
                    icon: 'fa-check',
                    colorClass: 'green',
                },
                {
                    label: this.$l10n.__('Bloqué'),
                    value: 'blocked',
                    icon: 'fa-lock',
                    colorClass: 'gray-60',
                },
                {
                    label: this.$l10n.__('Supprimé'),
                    value: 'deleted',
                    icon: 'fa-close',
                    colorClass: 'red',
                },
            ];
        },
        activeStatus() {
            return this.staffStatus.find((status) => status.value == this.sellsyadmin.staff_status);
        },
        staffTypes() {
            return [
                {
                    label: this.$l10n.__('Expert'),
                    value: 'accountant',
                    icon: 'chip-success',
                },
                {
                    label: this.$l10n.__('Sellsy'),
                    value: 'sellsy',
                    icon: 'chip-primary',
                },
                {
                    label: this.$l10n.__('Application API'),
                    value: 'application',
                    icon: 'chip-primary',
                },
                {
                    label: this.$l10n.__('Temporaire'),
                    value: 'temporary',
                    icon: 'chip-warning',
                },
                {
                    label: this.$l10n.__('Collaborateur'),
                    value: 'regular',
                    icon: 'chip-primary',
                },
            ];
        },
        activeStaffType() {
            return this.staffTypes.find(
                (staffType) => staffType.value == this.sellsyadmin.staff_type,
            );
        },
    },
};
</script>
